import apiClient from '../utils/apiClient';

/**
 * Reservation (đặt bàn) API services — read-only cho trang theo dõi của admin.
 */
export const reservationAPI = {
  /**
   * Danh sách đặt bàn theo chi nhánh + khoảng thời gian.
   * @param {{ branchId?: string, from?: string, to?: string }} params
   *   from/to: ISO datetime. Response: { data: TableReservation[] } —
   *   mỗi record kèm creator/preparer/arrivalChecker/statusChanger { full_name, role }.
   */
  getReservations: async (params = {}) => {
    return await apiClient.get({ url: '/reservations', params });
  },

  getReservationById: async (id) => {
    return await apiClient.get({ url: `/reservations/${id}` });
  },

  getPrepCriteria: async (branchId) => {
    return await apiClient.get({ url: '/reservations/prep-criteria', params: branchId ? { branch_id: branchId } : {} });
  },

  reviewPrep: async (id, body) => {
    return await apiClient.post({ url: `/reservations/${id}/prep-review`, data: body });
  },

  /**
   * #181944 — danh sách YÊU CẦU XÁC NHẬN khách đến.
   * @param {{ branchId?: string, from?: string, to?: string, outcome?: 'ARRIVED'|'NO_SHOW'|'AWAITING'|'SKIPPED' }} params
   *   Response: { data: ArrivalCheckRow[], summary: {...} }
   */
  getArrivalChecks: async (params = {}) => {
    return await apiClient.get({ url: '/reservations/arrival-checks', params });
  },

  /** #181944 — sửa lại phiếu bị đánh nhầm "khách không đến" (ADMIN/MANAGER, có ghi nhật ký). */
  resetArrivalCheck: async (id, body) => {
    return await apiClient.post({ url: `/reservations/${id}/arrival-check/reset`, data: body });
  },

  // Catalog tiêu chí chuẩn bị bàn (per-branch)
  listPrepCriteria: async (branchId) => {
    return await apiClient.get({ url: '/reservations/prep-criteria-catalog', params: branchId ? { branch_id: branchId } : {} });
  },
  createPrepCriterion: async (body) => {
    return await apiClient.post({ url: '/reservations/prep-criteria-catalog', data: body });
  },
  updatePrepCriterion: async (id, body) => {
    return await apiClient.patch({ url: `/reservations/prep-criteria-catalog/${id}`, data: body });
  },
  deletePrepCriterion: async (id) => {
    return await apiClient.delete({ url: `/reservations/prep-criteria-catalog/${id}` });
  },
};
